<template>
   <div id="ms-documentation" class="content content--borderless">
    <div class="content__breadcrumbs">
        <Breadcrumbs :items="breadcrumbs"></Breadcrumbs>
    </div>
    <div class="content__header">
      <div class="content__main-header">
        <div class="content__title">
          <div class="content__title__name">Pengaturan Daftar Pengguna</div>
          <div class="content__title__description">Daftar pengguna yang mempunyai akses di Indonesia Data Hub.</div>
        </div>
        <div class="ml-auto d-flex">
          <button type="button" class="button mr-2" variant="warning" size="sm" 
            @click="blastSdiUserPassword" v-if="$store.getters['auth/user'].username == 'mrizki.syazali'">
            <VueFeather type="send" size="16" stroke-width="2" style="display:block"></VueFeather>&nbsp;
            Blast Password User SDI
          </button>
          <button type="button" class="button" variant="primary" size="sm" @click="showModalAddNewUser" :disabled="userTable.items.length>=2 && sdiOrganization && sdiOrganization.role != 'PEMBINA_DATA'">
            <VueFeather type="user-plus" size="16" stroke-width="2" style="display:block"></VueFeather>&nbsp;
            Tambah Pengguna
          </button>
        </div>
      </div>
      <div class="tags" style="margin:0;padding:0" v-if="sdiOrganization">
        <div class="tag tag--primary">
          <div class="tag__field">Role</div>
          <div class="tag__value">{{capitalize(sdiOrganization.role)}}</div>
        </div>
        <div class="tag tag--secondary "> 
          <div class="tag__field">Level</div>
          <div class="tag__value">{{capitalize(sdiOrganization.level)}}</div>
        </div>
      </div>
      
    </div>
    <div class="content__body mt-3">
      <div class="alert alert--warning" v-if="sdiOrganization && sdiOrganization.role != 'PEMBINA_DATA'">
        <div class="alert__icon">
          <VueFeather type="alert-triangle" size="16"></VueFeather>
        </div>
        <div class="alert__value">
          Pada saat ini user yang diperbolehkan mengakses sistem adalah maksimal 2. Penambahan lebih dari 2 user dapat menghubungi Administrator. Terima Kasih.
        </div>
      </div>

      <div class="table-search mb-2 form form--sm">
        <b-input-group >
          <b-input-group-prepend is-text class="bg-none">
            <VueFeather type="search" size="16" stroke-width="3" stroke="#919191" ></VueFeather>
          </b-input-group-prepend>
          <b-form-input 
            type="search"
            debounce="500"
            v-model="filter.name" 
            placeholder="Cari user berdasarkan nama . . ." 
            class="border-left-0 min-w-400"></b-form-input>
        </b-input-group>
      </div>

      <div class="table-wrapper">
        
        <b-table
          class="table--light"
          show-empty
          :items="userTable.items"
          :fields="userTable.fields"
        >
          
          <template #cell(no)="data"> 
            {{  ((userTable.pagination.currentPage-1)*userTable.pagination.pageSize+1) + data.index }} 
          </template>
          <template #cell(sdiOrganization)="data"> 
            {{ data.item.sdiOrganization ? data.item.sdiOrganization.name  : '-' }} 
          </template>
          <template #cell(roles)="data">
            <div class="d-flex" v-for="(role,index) in data.value" :key="index">
              <div class="w-20 text-center" v-if="data.value.length>1">{{index+1}}.</div>
              <div>{{role ? roleFormatter(role.name)  : '-'}}</div>
            </div>
          </template>
          <template #cell(action)="data">
              <div class="d-flex justify-content-center">
                <!-- <b-link  
                    class="button button--action button--action--view " v-b-tooltip="{ title: 'Lihat Detail', placement: userTable.items.length>1 ? 'top' : 'bottom' }"
                > 
                    <VueFeather type="eye" size="14"></VueFeather>
                </b-link> -->
                <b-link  
                    class="button button--action button--action--edit " 
                    v-b-tooltip="{ title: 'Edit', placement: userTable.items.length>1 ? 'top' : 'bottom' }"
                    @click="showModalUpdateUser(data.item)"
                > 
                    <VueFeather type="edit-3" size="14"></VueFeather>
                </b-link>
                <b-link  
                    class="button button--action button--action--edit " v-b-tooltip="{ title: 'Kirim Password', placement: userTable.items.length>1 ? 'top' : 'bottom' }"
                    @click="resendUserPassword(data.item.id)"
                    :disabled="data.item.email.split('@')[1] == 'bps.go.id'"
                > 
                    <VueFeather type="send" size="14"></VueFeather>
                </b-link>
              </div>
          </template>
          <template #empty>
              <div class="table__empty">
              <div v-if="userTable.isLoading">
                <VueFeather type="loader" animation="spin" size="18"></VueFeather> &nbsp; Memuat data</div>
              <div v-else>
                <VueFeather type="alert-circle" size="18"></VueFeather> &nbsp;
                    Belum ada data pengguna yang tersedia
              </div>
              </div>
          </template>
        </b-table>
      </div>
      <b-pagination
        class="mt-3 pb-5 "
        align="center"
        v-model="userTable.pagination.currentPage"
        :total-rows="userTable.pagination.totalElements"
        :per-page="userTable.pagination.pageSize"
        @input="doFilter"
      ></b-pagination>
    </div>
    <b-toast id="toast" variant="danger" solid body-class="text-manrope text-medium" no-close-button toaster="b-toaster-top-center">
      <template #toast-title>
        <div class="d-flex flex-grow-1 align-items-center text-manrope text-semi-bold">
          <b-img blank blank-color="#e32929" class="mr-2" width="10" height="10"></b-img>
          <strong class="mr-auto">{{toast.title}}!</strong>
          <small class="text-muted mr-2">{{toast.time}}</small>
        </div>
      </template>
      {{toast.message}}
    </b-toast>

    <b-modal hide-header hide-footer size="md" id="modal-add-update-user" modal-class="modal-secondary primary">
      <div class="modal__header secondary">
         <div class="modal__header__icon"><VueFeather type="user-plus" size="18" stroke-width="2"></VueFeather></div>
         <div>
          <div class="modal__title">  {{ newUser ? 'Tambah' : 'Update'}} Pengguna </div>
          <div class="modal__description">Isikan secara lengkap form yang disediakan </div>
         </div>
         <div class="modal__header__close">
          <b-button  class="button button--action button--action--view" @click="$bvModal.hide('modal-add-update-user')">
              <VueFeather type="x" size="14" stroke-width="2"></VueFeather>
          </b-button>
         </div>
      </div>
      <div class="modal__body mb-2 form form--sm">
        <ValidationObserver ref="userObserver" v-slot="{validate}">
          <b-form-group label="Jenis Pengguna">
              <b-form-radio-group  v-model="user.isSso">
                <b-form-radio :value="true" style="line-height:1.3;" >Internal BPS</b-form-radio>
                <b-form-radio :value="false" style="line-height:1.3;" >Pengguna Eksternal</b-form-radio>
              </b-form-radio-group>
          </b-form-group>
          
          <ValidationProvider name="Username akun SSO BPS" :rules="newUser ? 'required' : ''" v-slot="{errors}" v-if="user.isSso" >
            <b-form-group label="Username akun SSO BPS">
                <Treeselect 
                  clearable
                  valueFormat="object"
                  placeholder="Username"
                  v-model="ssoUser"
                  :async="true"
                  :options="options.ssoUser"
                  :loadOptions="ssoUserLoadOptions"
                  :normalizer="ssoUserNormalizer"
                  searchPromptText="Ketikkan beberapa huruf terlebih dahulu untuk memulai pencarian... "
                  @input="()=>{
                    if(ssoUser){
                      user.name = ssoUser.name;
                      user.email= ssoUser.email;
                      user.username = user.email.split('@')[0];
                    }else{
                      user.name = null;
                      user.email= null;
                      user.username = null;
                    } 
                  }"
                />
                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
            </b-form-group>
          </ValidationProvider>

          <ValidationProvider name="Nama" rules="required" v-slot="{errors}">
              <b-form-group label="Nama">
                <b-form-input 
                  v-model="user.name" 
                  placeholder="Tuliskan nama lengkap pengguna"
                  :state="errors[0] ? false: (user.name ? true : null)"
                  :disabled="user.isSso"
                >
                </b-form-input>
                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
          </ValidationProvider>

          <ValidationProvider name="Email" rules="required|email" v-slot="{errors}">
              <b-form-group label="Email" description="Pastikan alamat email aktif, karena informasi alamat e-mail akan digunakan system untuk mengirimkan password pengguna">
                <b-form-input 
                    v-model="user.email" 
                    placeholder="Email aktif pengguna"
                    :state="errors[0] ? false: (user.email ? true : null)"
                    :disabled="user.isSso"
                    @input="isDuplicateError = false; user.username = user.email.split('@')[0];"
                >
                </b-form-input>
                <b-form-invalid-feedback :state="false">{{ errors[0] }}</b-form-invalid-feedback>
              </b-form-group>
          </ValidationProvider>

          <b-form-group label="Role">
            <Treeselect 
              v-model="user.roleIds"
              :clearable="false"
              :options="options.roles"
              :multiple="isSuperAdmin ? true : false"
              :normalizer="(node)=>({id:node.id, label:node.name})"
              :disabled="!isSuperAdmin"
            >
              <label slot="option-label" slot-scope="{node,labelClassName}" :class="labelClassName">
                {{getRoleNameById(node.id) }}
              </label>
              <div slot="value-label" slot-scope="{ node }">{{ getRoleNameById(node.id) }}</div>
            </Treeselect>
          </b-form-group>

          <b-form-group label="Organisasi" v-if="isSdiRoles(user.roleIds)">
            <Treeselect 
              clearable
              valueFormat="object"
              placeholder="Pilih organisasi user"
              v-model="user.sdiOrganization"
              :async="true"
              :options="null"
              :loadOptions="sdiOrganizationLoadOptions"
              :normalizer="sdiOrganizationNormalizer"
              searchPromptText="Ketikkan beberapa huruf terlebih dahulu untuk memulai pencarian... "
            />
          </b-form-group>

          


          <div class="alert alert--danger" v-if="isDuplicateError && newUser">
            <div class="alert__icon">
              <VueFeather type="alert-triangle" size="16"></VueFeather>
            </div>
            <div class="alert__value">
              Akun dengan email tersebut sudah ditambahkan! gunakan email yang lain
            </div>
          </div>
        
          <div class="d-flex align-items-center justify-content-end">
              <b-button  v-if="newUser" class="button button--primary" :disabled="userExist(user.email)" @click="()=>{
                validate().then(result=>{
                    if(result){
                      addUser();
                    }
                })   
              }">Simpan</b-button>
              <b-button v-if="!newUser" class="button button--primary" @click="()=>{
                validate().then(result =>{
                    if(result){
                      updateUser();
                    }
                })   
              }" >Update</b-button>
          </div>
        </ValidationObserver>
      </div>
   </b-modal>

    <b-modal  
      id="access-server" size="sm"
      hide-header hide-footer  content-class="text-center py-3 px-3" centered dialog-class="d-flex justify-content-center"
    >
      <div v-if="modal.accessServer.isLoading">
        <div class="text-center py-3">
          <img src="@/assets/img/loader.gif" width="100" height="100" />
          <div style="font-weight:600;font-size:16px;color:#01ad85">
            Mohon tunggu sebentar 
          </div>
          <div style="font-weight:500;font-size:13px;color:#0a4e5c;">
            {{modal.accessServer.loadingMessage}}
          </div>
        </div>
      </div>
      <div v-else>
        <div class="text-center py-3" style="color:red">
          <div >
            <VueFeather type="x-circle" size="50" stroke-width="1"></VueFeather>
          </div>
          <div style="font-weight:600;font-size:17px;color:red">
            Error 
          </div>
          <div style="font-weight:600;font-size:13px;color:#0a4e5c;font-family:'Open Sans'">
            {{modal.accessServer.errorMessage}}
          </div>
          <div class="mt-2">
            <b-button 
              style="background-color:#2e2e2e !important;padding:3px 10px;border-radius:3px !important; font-weight:600" 
              v-on:click="()=>{$bvModal.hide('access-server');}">Kembali</b-button>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
  
</template> 
<script>
import wilayahService from "@/services/WilayahService";
import SdiOrganizationService from "@/services/SdiOrganizationService";
import UserService from "@/services/UserService";
import moment from 'moment'
import VueFeather from 'vue-feather';
import { ValidationObserver,ValidationProvider } from "vee-validate";
import Breadcrumbs from "@/components/Breadcrumbs";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import store from "@/store";
import * as role from "@/views/ms/SdiRole.js"
import lodash from "lodash"
export default {
  components:{
    VueFeather,
    ValidationObserver,
    ValidationProvider,
    Treeselect,
    Breadcrumbs
  },
  data(){
    return{
      sdiOrganization: null,
      breadcrumbs:[
         {
            text:'Beranda',
            href:'/',
         },
         {
            text:'Pengaturan',
            href:'#',
         },
         {
            text:'User',
            href:'',
            active:true,
         }
      ],
      toast:{
        title:null,
        message:null,
        time:null
      },
      provinceFilterDisabled:false,
      cityFilterDisabled:false,
      filter:{
         name:null,
         provinceCode:null,
         cityCode: null,
         sdiRole:null,
         sdiOrganizationId:null,
      },
      userTable:{
        isLoading: true,
        items:[],
        pagination:{
          currentPage:1,
          pageSize: 10,
          totalPages: null,
          totalElements:0,
          goto:null
        },
        fields:[
          {
              key:'no',
              class:'text-center w-51'
          },
          {
              key:'name',
              label: 'Nama',
              class:'text-left'
          },
          {
              key:'email',
              class:'text-left'
          },
          {
              key: 'username',
              label: 'username',
              class:'text-left'
          },
          {
              key:'roles',
              label:'Role',
              class:'text-left '
          },
          {
              key:'sdiOrganization',
              label:'Organisasi SDI',
              class:'text-left '
          },
          {
              key:'action',
              label: 'Aksi',
              class:'text-center text-nowrap w-101'
          },
        ],
      },
      user:{
        name:null,
        username:null,
        email:null,
        sdiOrganization:null,
        roleIds:[],
        isSso:false,
      },
      userRoles:null,
      ssoUser:null,
      newUser:true,
      updatedUserId:null,
      isDuplicateError:false,
      modal:{
        accessServer:{
          isLoading:false,
          loadingMessage:null,
          isError:false,
          errorMessage:null,
          
        },
      },

      options:{
        roles:[],
        ssoUser: null,
        sdiRole:[
          {id:'PEMBINA_DATA', label : 'Pembina Data'},
          {id:'WALIDATA', label : 'Walidata'},
          {id:'PRODUSEN_DATA', label : 'Produsen Data'}
        ],
        province:[
          {
            id: 0,
            code: '00',
            name: "PUSAT",
          },
          {
            id: 1,
            code: '11',
            name: "ACEH"
          },
          {
            id: 2,
            code: '12',
            name: "SUMATERA UTARA"
          },
          {
            id: 3,
            code: '13',
            name: "SUMATERA BARAT"
          },
          {
            id: 4,
            code: '14',
            name: "RIAU"
          },
          {
            id: 5,
            code: '15',
            name: "JAMBI"
          },
          {
            id: 6,
            code: '16',
            name: "SUMATERA SELATAN"
          },
          {
            id: 7,
            code: '17',
            name: "BENGKULU"
          },
          {
            id: 8,
            code: '18',
            name: "LAMPUNG"
          },
          {
            id: 9,
            code: '19',
            name: "KEPULAUAN BANGKA BELITUNG"
          },
          {
            id: 10,
            code: '21',
            name: "KEPULAUAN RIAU"
          },
          {
            id: 11,
            code: '31',
            name: "DKI JAKARTA"
          },
          {
            id: 12,
            code: '32',
            name: "JAWA BARAT"
          },
          {
            id: 13,
            code: '33',
            name: "JAWA TENGAH"
          },
          {
            id: 14,
            code: '34',
            name: "DI YOGYAKARTA"
          },
          {
            id: 15,
            code: '35',
            name: "JAWA TIMUR"
          },
          {
            id: 16,
            code: '36',
            name: "BANTEN"
          },
          {
            id: 17,
            code: '51',
            name: "BALI"
          },
          {
            id: 18,
            code: '52',
            name: "NUSA TENGGARA BARAT"
          },
          {
            id: 19,
            code: '53',
            name: "NUSA TENGGARA TIMUR"
          },
          {
            id: 20,
            code: '61',
            name: "KALIMANTAN BARAT"
          },
          {
            id: 21,
            code: '62',
            name: "KALIMANTAN TENGAH"
          },
          {
            id: 22,
            code: '63',
            name: "KALIMANTAN SELATAN"
          },
          {
            id: 23,
            code: '64',
            name: "KALIMANTAN TIMUR"
          },
          {
            id: 24,
            code: '65',
            name: "KALIMANTAN UTARA"
          },
          {
            id: 25,
            code: '71',
            name: "SULAWESI UTARA"
          },
          {
            id: 26,
            code: '72',
            name: "SULAWESI TENGAH"
          },
          {
            id: 27,
            code: '73',
            name: "SULAWESI SELATAN"
          },
          {
            id: 28,
            code: '74',
            name: "SULAWESI TENGGARA"
          },
          {
            id: 29,
            code: '75',
            name: "GORONTALO"
          },
          {
            id: 30,
            code: '76',
            name: "SULAWESI BARAT"
          },
          {
            id: 31,
            code: '81',
            name: "MALUKU"
          },
          {
            id: 32,
            code: '82',
            name: "MALUKU UTARA"
          },
          {
            id: 33,
            code: '91',
            name: "PAPUA BARAT"
          },
          {
            id: 34,
            code: '94',
            name: "PAPUA"
          }
        ],
        city:[
          {
            id: 0,
            code: '0000',
            name: "PUSAT",
            provinsiId:null
          }
        ]
      }
    }
  },
  watch:{
    'filter.provinceCode'(){
        this.provinceChanged(this.filter.provinceCode); 
    },
    'filter.name'(){
        this.doFilter()
    }
  },
  computed:{
    isSuperAdmin(){
      return store.getters["auth/user"].role.slice(1,-1).split(", ").includes("ROLE_SUPERADMIN");
    },
    role(){
      return role;
    },
    
  },
  async mounted(){
    this.userRoles = store.getters["auth/user"].role.slice(1,-1).split(", ");
    //superadmin            -> pembina data provinsi (user bps via sso) / all user
    //pembina data pusat    -> pembina data provinsi (user bps via sso) & assign user walidata pusat (max 2)
    //pembina data provinsi -> pembina data kabkota  (user bps via sso) & assign user walidata provinsi (max 2)
    //pembina data kabkota  -> assign user walidata kabkota (max 2)
    this.getAllUser();
    this.getAllRoles();
    // if(role.isSuperAdmin){
      
      
    // }else{
    //   await this.getSdiOrganizationDetail(id);
    //   await this.getSdiRoles();
    //   this.setUserRoles();
    // }
    
  },
  methods:{
    doFilter(){
      this.scrollTop()
      this.getAllUser();
    },
    async getAllUser(){
      this.userTable.items = [];
      this.userTable.isLoading = true;
      let name = this.filter.name;
      let page = this.filter.name ? 0 : this.userTable.pagination.currentPage -1;
      await UserService.getAllUser(page, name, null).then(
        (result) =>{
          this.userTable.items = result.data.content;
          this.userTable.pagination.pageSize = result.data.size;
          this.userTable.pagination.totalElements = result.data.totalElements;
        },
      ).catch(error=>{
        this.toast.title = 'Gagal Menyimpan Data';
        this.toast.message = JSON.parse(JSON.stringify(error)).message;
        this.toast.time = moment().startOf('second').fromNow(); 
        this.$bvToast.show('toast');
      });
      
      this.userTable.isLoading = false;
    },
    async resendUserPassword(id){
      this.modal.accessServer.isLoading = true;
      this.modal.accessServer.loadingMessage = 'Proses mengirimkan password terbaru sedang dikirimkan';
      this.$bvModal.show('access-server');
      await UserService.resendUserPassword(id).then(
        () =>{
           this.$bvModal.hide('access-server');
        },
      ).catch(error=>{
        this.modal.accessServer.isLoading = false;
        this.modal.accessServer.errorMessage = error.response;
      });
    },
    async blastSdiUserPassword(){
      this.modal.accessServer.isLoading = true;
      this.modal.accessServer.loadingMessage = 'Proses Blast Password ke semua User SDI sedang berlangsung';
      
      this.$bvModal.show('access-server');
      await UserService.blastSdiUserPassword().then(
        () =>{
          this.$bvModal.hide('access-server');
        },
      ).catch(error=>{
        this.modal.accessServer.isLoading = false;
        this.modal.accessServer.errorMessage = error.response;
      });
    },
    async addUser(){
      this.isDuplicateError = false;
      let sdiOrganization = {...this.user.sdiOrganization};
      delete this.user.sdiOrganization;
      this.user.sdiOrganizationId = sdiOrganization ? sdiOrganization.id : null;
      await UserService.addUser(this.user).then(
        () =>{
          this.$bvModal.hide('modal-add-update-user');
          this.getAllUser();
        },
      ).catch(error=>{
        if(error.response.data.status == 409){
          this.isDuplicateError = true;
        }else{
          this.toast.title = 'Gagal Menyimpan Data';
          this.toast.message = JSON.parse(JSON.stringify(error)).message;
          this.toast.time = moment().startOf('second').fromNow(); 
          this.$bvToast.show('toast');
        }
      });
    },
    async updateUser(){
      let sdiOrganization = {...this.user.sdiOrganization};
      delete this.user.sdiOrganization;
      this.user.sdiOrganizationId = sdiOrganization ? sdiOrganization.id : null;
      await UserService.updateUser(this.updatedUserId,this.user).then(
        () =>{
          this.$bvModal.hide('modal-add-update-user');
          this.getAllUser();
        },
      ).catch(error=>{
        this.toast.title = 'Gagal Menyimpan Data';
        this.toast.message = JSON.parse(JSON.stringify(error)).message;
        this.toast.time = moment().startOf('second').fromNow(); 
        this.$bvToast.show('toast');
      });
    },
    showModalAddNewUser(){
      this.isDuplicateError = false;
      this.newUser = true;
      this.ssoUser=null;
      this.$bvModal.show('modal-add-update-user');
      this.user ={
        name:null,
        username:null,
        email:null,
        sdiOrganization:null,
        roleIds:[],
        isSso:false,
      }
    },
    showModalUpdateUser(user){
      this.isDuplicateError = false;
      this.updatedUserId = user.id;
      this.newUser = false;
      let isSso = user.email && user.email.split('@')[1] == 'bps.go.id';
      this.$bvModal.show('modal-add-update-user');
      this.user ={
        name:user.name,
        username:user.username,
        email:user.email,
        sdiOrganization:user.sdiOrganization,
        roleIds:user.roles.map(x=>x.id),
        isSso: isSso,
      }
    },
    async getSdiOrganizationDetail(id){
      this.userTable.isLoading = true;
      await SdiOrganizationService.getSdiOrganizationById(id).then(
        (result) =>{
          this.sdiOrganization = {...result.data};
          this.userTable.items = this.sdiOrganization.users;
          this.user.sdiOrganization.id = this.sdiOrganization.id;
          if(this.sdiOrganization.role == 'PEMBINA_DATA'){this.user.isSso = true}
        },
      ).catch(error=>{
        console.log(JSON.parse(JSON.stringify(error)));
        this.toast.title = 'Gagal Menarik Data User';
        this.toast.message = JSON.parse(JSON.stringify(error)).message;
        this.toast.time = moment().startOf('second').fromNow(); 
        this.$bvToast.show('toast');
      });
      this.userTable.isLoading = false;
    },
    async getAllRoles(){
      await UserService.getAllRoles().then(
        (result) =>{
          this.options.roles = result.data.map(x=>({id:x.id,name:x.role, project:x.project}));
          this.options.roles = lodash.orderBy(this.options.roles, ['project','name'],['asc','asc'])
        },
      ).catch(error=>{
        this.toast.title = 'Gagal Menarik Data Roles';
        this.toast.message = JSON.parse(JSON.stringify(error)).message;
        this.toast.time = moment().startOf('second').fromNow(); 
        this.$bvToast.show('toast');
      });
    },
    setUserRoles(){
      let role = this.sdiOrganization.role;
      let level = this.sdiOrganization.level;
      if(role == 'PEMBINA_DATA'){
        this.user.roleIds = 
          level == 'PUSAT' ? [this.roleId('ROLE_PEMBINA_DATA_PUSAT')] : (
          level == 'PROVINSI' ? [this.roleId('ROLE_PEMBINA_DATA_PROVINSI')] : [this.roleId('ROLE_PEMBINA_DATA_KABKOT')] )
      }else if(role == 'WALIDATA'){
        this.user.roleIds = 
          level == 'PUSAT' ? [this.roleId('ROLE_WALIDATA_PUSAT')] : (
          level == 'PROVINSI' ? [this.roleId('ROLE_WALIDATA_PROVINSI')] : [this.roleId('ROLE_WALIDATA_KABKOT')] )
      }else{
        this.user.roleIds = 
          level == 'PUSAT' ? [this.roleId('ROLE_PRODUSEN_DATA_PUSAT')] : (
          level == 'PROVINSI' ? [this.roleId('ROLE_PRODUSEN_DATA_PROVINSI')] : [this.roleId('ROLE_PRODUSEN_DATA_KABKOT')] )
      }
    },
    isSdiRoles(roleIds){
      let sdiRoleIds = this.options.roles.filter(x=>x.project == 'SDI').map(x=>x.id);
      return roleIds.some( role => sdiRoleIds.includes(role))
    },
    getRoleNameById(id){
      if(!this.options.roles || this.options.roles.length == 0){
        return '-'
      }
      let role = this.options.roles.find(x=> x.id == id);
      return this.roleFormatter(role.name)
    },
    roleFormatter(roleName){
      if(!roleName){
        return '-'
      }
      roleName = roleName.replace('ROLE_','')
      roleName = roleName.replace('_',' ')
      roleName = roleName.replace('KABKOTA','Kabupaten/Kota')
      return this.capitalize(roleName);
    },
    roleId(roleName){
      let role = this.options.roles.length>0 ? this.options.roles.find(x=>x.name == roleName) : null;
      return role ? role.id :null
    },
    capitalize(sentence){
      return sentence ? sentence.replaceAll('_',' ').toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase()) : '-';
    },
    async ssoUserLoadOptions({searchQuery, callback}){
      await UserService.getSsoUserByUsername(searchQuery).then(
        (result) => {
          let options = result.data.result.map((element) => {
            return {
              name: element.firstName + " " + element.lastName,
              username: element.username,
              email: element.email,
            };
          });
          callback(null, options)
        },

        (error) => {
          console.log(error);
        }
      );
    },
    ssoUserNormalizer(node) {
      return {
        id: node.username,
        label: node.name,
      }
    },
    userExist(email){
      if(!email){
        return false;
      }
      let users = this.userTable.items.map(x=>x.email);
      return users.includes(email);
      
    },

    sdiOrganizationNormalizer(node) {
      return {
         id: node.id,
         label: node.name,
      }
    },
    loadOptions({callback}) {
      let result = 'Sedang melakukan load data'
      callback(null, result)
    },
    async sdiOrganizationLoadOptions({searchQuery, callback}){
        let name = searchQuery;
        let page = 0;
        let provinceCode = null;
        let cityCode = null;
        await SdiOrganizationService.getAllSdiOrganization(page, name, provinceCode, cityCode).then(
          (result)=>{
              let options = result.data.content;
              // console.log(options)
              callback(null, options)
          },
          (error)=>{
              console.log(error)
          }
        )
    },
    walidataChanged(){
        this.organization.walidata = {id:this.walidata.id, name:this.walidata.name};
    },
    normalizer(node) {
        return {
          id: node.value,
          label: node.label,
          children: node.children,
        }
    },
    provinceNormalizer(node){
        return {
          id: node.code,
          label: node.name,
        }
    },
    cityNormalizer(node){
        return {
          id: node.code,
          label: node.name,
        }
    },
    provinceChanged(provCode){
      if(!this.provinceFilterDisabled || !this.cityFilterDisabled){
         this.filter.cityCode=null;
         if(provCode == '00'){
            this.options.city = [{
               id: 0,
               code: '0000',
               name: "PUSAT",
               provinsiId:null
            }];
         }else{
            if(provCode){
               let prov = this.options.province.find(x=>x.code == provCode);
               this.getKabupatenKotaList(prov.id, provCode);
            }
         }
      }
      if(this.provinceFilterDisabled && this.cityFilterDisabled){
         if(provCode){
            let prov = this.options.province.find(x=>x.code == provCode);
            this.getKabupatenKotaList(prov.id, provCode);
         }
      }
   },
   async getKabupatenKotaList(provinceId, provinceCode){
      wilayahService.getKabupatenKotaByIdProvinsi(provinceId).then(
         (result) => {
               let options = result.data.data;
               this.options.city = options.map(x=>({id:x.id, code:x.kode,name:x.nama}));
               this.options.city = [
                  {
                     id: 9999,
                     code: provinceCode+'00',
                     name: "PROVINSI",
                  }, ...this.options.city]
         },
         (error) => {
               this.error=error;
         }
      );
   },
    scrollTop() {
      // setTimeout(function() {}, 100);
      window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
    },
  }
}
</script>